import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Applicant } from '@app/models/recruiting/applicant.model';

const sendOfferPathParams = ['/', 'employees', 'offer-letters', 'new'] as const;
interface SendOfferQueryParams {
    firstName: string;
    lastName: string;
    email: string;
    atsApplicantId: number;
}
export interface SendOfferClickEvent {
    pathParams: typeof sendOfferPathParams;
    queryParams: SendOfferQueryParams;
}

const hireApplicantPathParams = ['/', 'employees', 'directory', 'create'] as const;
interface HireApplicantQueryParams {
    atsApplicantId: number;
    email: string;
    firstName: string;
    lastName: string;
    offerLetterSignedAt: Date | null;
    fromURL: 'recruiting';
    candidateId: number | null;
}
export interface HireClickEvent {
    pathParams: typeof hireApplicantPathParams;
    queryParams: HireApplicantQueryParams;
}

@Component({
    selector: 'app-hire-drop-down',
    templateUrl: './hire-drop-down.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HireDropDownComponent {
    @Input() applicant: Applicant;

    @Output() sendOfferClicked: EventEmitter<SendOfferClickEvent> = new EventEmitter<SendOfferClickEvent>();
    @Output() hireClicked: EventEmitter<HireClickEvent> = new EventEmitter<HireClickEvent>();

    constructor() {}

    onSendOffer(): void {
        this.sendOfferClicked.emit({
            pathParams: sendOfferPathParams,
            queryParams: {
                firstName: this.applicant.firstName,
                lastName: this.applicant.lastName,
                email: this.applicant.email,
                atsApplicantId: this.applicant.id,
            },
        });
    }

    onHire(): void {
        this.hireClicked.emit({
            pathParams: hireApplicantPathParams,
            queryParams: {
                atsApplicantId: this.applicant.id,
                email: this.applicant.email,
                firstName: this.applicant.firstName,
                lastName: this.applicant.lastName,
                offerLetterSignedAt: this.applicant.connectEmployeeLink?.offerAcceptedDate,
                fromURL: 'recruiting',
                candidateId: this.applicant.connectEmployeeLink?.candidateId, // This is required in order to bypass the validation check against pending/incomplete offer letter process
            },
        });
    }
}
